import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Row, Col, Card, Form, Alert } from 'react-bootstrap';
import { FROST_PROBE_CONFIG, SENSOR_PLACEMENT_CONFIG, SNOW_POLE_CONFIG } from '@awp/constants';
import AwpSpinner from '@components/Common/AwpSpinner';
import AwpMultiSwitch from '@awp/components/Common/AwpMultiSwitch';
import CreateSensorPlacementModal from './CreateSensorPlacementModal';
import { isValueEmpty, isObjectEmpty } from '@awp/helpers/utilsReact';
import Authorize from '@awp/components/Authorize';
import { Permissions } from '@awp/constants';
import Placement from './Placement';
import {
  getCurrentSensorEquipmentPacket,
  isLoading,
  hasLoaded,
  isEditing,
  setData,
} from '@stores/sensorEquipmentPacketSlice';

const PlacementList = () => {
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const loaded = useSelector(hasLoaded);
  const inEditing = useSelector(isEditing);
  const sensorEquipmentPacket = useSelector(getCurrentSensorEquipmentPacket);
  const [createModal, setCreateModal] = useState(false);

  const isOtherEditing = () => {
    return !isValueEmpty(inEditing);
  };

  const handleModalClosed = useCallback(() => {
    setCreateModal(false);
  }, []);

  const onSwitchToggle = (selectedItem) => {
    let _data = { ...sensorEquipmentPacket };
    let _sensorEquipmentSets = _data.SensorEquipmentSets;
    let _newSensorEquipmentSets = [];
    _sensorEquipmentSets.map((sp) => {
      let _sp = { ...sp };
      _sp.IsCollapsed = selectedItem === 1 ? 2 : 1;
      if (_sp.PlacementSegments && _sp.PlacementSegments.length > 0) {
        let _newPlacementSegments = [];
        _sp.PlacementSegments.map((seg) => {
          let _seg = { ...seg };
          _seg.IsSegCollapsed = _sp.IsCollapsed;
          _newPlacementSegments.push(_seg);
        });
        _sp.PlacementSegments = _newPlacementSegments;
      }
      _newSensorEquipmentSets.push(_sp);
    });
    _data.SensorEquipmentSets = _newSensorEquipmentSets;
    dispatch(setData(_data));
  };
  return (
    <div className="card mb-5">
      <div className="card-header" style={{ backgroundColor: 'white' }}>
        <div className="d-flex">
          <div className="container">
            <div className="row">
              <div className="col" style={{ paddingLeft: '0rem' }}>
                <div className="container" style={{ paddingLeft: '0rem' }}>
                  <div className="row">
                    <div className="col" style={{ marginBottom: '15px' }}>
                      <h4 className="flex-grow-1 mb-0">Sensor Placements</h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <AwpMultiSwitch
                        texts={['Collapsed', 'Expanded']}
                        bgColor={'#666666'}
                        selectedSwitchColor={'#003366'}
                        fontColor={'#fff'}
                        height={'40px'}
                        eachSwitchWidth={'5.4'}
                        fontFamily={'BCSans'}
                        fontSize={'85%'}
                        selectedSwitch={0} //index of texts for default selected
                        //eachSwitchWidth={'3.6'}//rem
                        onToggle={onSwitchToggle}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="js-message-container"></div>

        <div>
          <div>
            {loading && <AwpSpinner />}
            {loaded &&
            (!sensorEquipmentPacket ||
              !sensorEquipmentPacket.SensorEquipmentSets ||
              sensorEquipmentPacket.SensorEquipmentSets.length === 0) ? (
              <div>No placements found</div>
            ) : (
              loaded && (
                <>
                  {sensorEquipmentPacket.SensorEquipmentSets.map((placement, i) => {
                    return placement && <Placement key={i} placement={placement} />;
                  })}
                </>
              )
            )}
          </div>
        </div>
      </div>
      <div className="col" style={{ display: 'flex', marginBottom: '15px' }}>
        <Authorize requires={[Permissions.WriteSensorPlacement]}>
          <Button
            variant="primary"
            className="align-self-center form-control-lg"
            onClick={() => setCreateModal(!createModal)}
            style={{ whiteSpace: 'nowrap' }}
            disabled={isOtherEditing()}
          >
            Create Sensor Placement
          </Button>
        </Authorize>
      </div>
      <CreateSensorPlacementModal visible={createModal} closeModal={handleModalClosed} />
    </div>
  );
};

PlacementList.propTypes = {};

export default PlacementList;
